const HomeData = {
  blog: {
    filters: [
      {
        title: 'All news',
        active: true,
        id: 'filter_1',
      },
      {
        title: 'Market analytics',
        id: 'filter_2',
      },
      {
        title: 'New in Cirrusoft',
        id: 'filter_3',
      },
      {
        title: 'Future of retail',
        id: 'filter_4',
      },
      {
        title: 'Data management',
        id: 'filter_5',
      },
    ],
  },
};

export default HomeData;
